import { Component, Input } from "@angular/core";
import { UpsellWhyContentItem } from "src/app/models/upsell-why-content";

@Component({
  selector: "upsell-why",
  templateUrl: "upsell-why.html",
  styleUrls: ["upsell-why.scss"],
})

export class UpsellWhyComponent {

  /**
   * @apiDescription Used to render content
   * @apiParam {content} Array containing content objects
   * @apiParamExample {content} Example input Array
   *  [{
   *    label: 'Step 1',
        active: false,
        showCheck: true
      }, {
   *    label: 'Step 2',
   *    active: true,
   *    showCheck: true
   *  }]
   */
  @Input() content: UpsellWhyContentItem[] = [];

  constructor() {}

  trackByFn(index: number, item: UpsellWhyContentItem): string | number {
    return item?.id || index;
  }
}